import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import { StyleSheet, css } from 'aphrodite'
import { useTranslation } from 'react-i18next'
import {
  COLOR_WHITE,
  COLOR_BLACK,
  COLOR_ORANGE_GRADIENT,
} from '../../lib/colors'
import UIHighlightedTitle from '../../components/UI/UIHighlightedTitle'
import Slider from 'react-slick'
import chevron from '../../assets/chevron.svg'
import UIButtonIcon from '../../components/UI/UIButtonIcon'
import { BP_XS } from '../../lib/breakpoints'

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    margin: 0,
    overflow: 'hidden',
    color: COLOR_WHITE,
    fontWeight: 700,
    letterSpacing: '-0.05em',
    padding: '3em 0',
    background: '#17B6C5',
    '@media (max-width: 480px)': {
      margin: '0',
      padding: '80px 20px 40px 20px',
    },
  },
  image: {
    transform: 'translateX(-100%)',
    '@media (max-width: 480px)': {
      width: '70px',
      height: '70px',
    },
  },
  containerTitle: {
    display: 'flex',
    marginBottom: '2em',
    '@media (max-width: 1024px)': {
      flexDirection: 'column',
      paddingLeft: '20px',
    },
  },
  title: {
    margin: 0,
    fontSize: '2.5em',
    marginRight: '0.3em',
    '@media (max-width: 480px)': {
      fontSize: '2em',
    },
  },
  containerItem: {
    width: '95%',
    padding: '10%',
    height: '400px',
    textAlign: 'center',
    backgroundColor: COLOR_WHITE,
    color: COLOR_BLACK,
    borderRadius: '10px',
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    '@media (max-width: 1024px)': {
      height: '600px',
      padding: '0',
    },
  },
  containerChevron: {
    display: 'flex',
    alignItems: 'center',
    alignSelf: 'center',
    marginTop: '2em',
  },
  chevronLeft: {
    transform: 'scale(-1, -1)',
    cursor: 'pointer',
    width: '2em',
  },
  chevronRight: {
    cursor: 'pointer',
    width: '2em',
  },
  containerSlider: {
    width: '100vw',
    fontWeight: 700,
    '@media (max-width: 480px)': {
      width: 'auto',
    },
  },
  highlighted: {
    margin: '0 10px 0 0',
    '@media (max-width: 480px)': {
      margin: '10px 0 0 0',
    },
  },
  itemH3: {
    minHeight: '80px',
    marginBottom: 0,
    color: COLOR_WHITE,
    fontSize: '25px',
    '@media (max-width: 480px)': {
      fontSize: '15px',
      padding: '0 10px',
    },
  },
})

const Optimization = () => {
  const { t } = useTranslation('translation')
  const slider = useRef()

  const settings = {
    centerMode: true,
    infinite: true,
    speed: 500,
    swipe: true,
    arrows: false,
  }

  const listItems = [
    {
      background: 'info_back.jpg',
      title: "Vous avez le statut d'auto-entrepreneur ?",
      img: 'info.png',
    },
    {
      background: 'horloge_back.jpg',
      title:
        'Vous gagnez 15€ par heure de captation. \n Une heure entamée, non terminée, est payée',
      img: 'horloge.png',
    },
    {
      background: 'euro_back.jpg',
      title: 'Vous choissisez vos horaires',
      img: 'euro.png',
    },
    {
      background: 'planete_back.jpg',
      title: 'C’est bon pour la Planète',
      img: 'planete.png',
    },
  ]

  const next = () => {
    slider.current.slickNext()
  }

  const previous = () => {
    slider.current.slickPrev()
  }

  return (
    <>
      <div id="optimization" className={css(styles.container)}>
        <div className={css(styles.containerTitle)}>
          <UIHighlightedTitle
            value={t('pages.beAMaker.EarnMoney')}
            fontSize={window.innerWidth < BP_XS ? '2em' : '2.5em'}
            dynamicStyle={styles.highlighted}
            backgroundColor={COLOR_ORANGE_GRADIENT}
          />
          <p className={css(styles.title)}>
            {t('pages.beAMaker.optimizeYourTime')}
          </p>
        </div>
        <div className={css(styles.containerSlider)}>
          <Slider
            ref={slider}
            {...settings}
            slidesToShow={window.innerWidth < BP_XS ? 1 : 2}
          >
            {listItems.map(({ title, img, background }, index) => (
              <Item
                key={index}
                title={title}
                img={img}
                background={background}
              />
            ))}
          </Slider>
        </div>
        <div className={css(styles.containerChevron)}>
          <UIButtonIcon onClick={previous}>
            <img
              src={chevron}
              className={css(styles.chevronLeft)}
              alt="chevron left"
              width="2em"
              height="auto"
            />
          </UIButtonIcon>
          <UIButtonIcon onClick={next}>
            <img
              src={chevron}
              className={css(styles.chevronRight)}
              alt="chevron right"
              width="2em"
              height="auto"
            />
          </UIButtonIcon>
        </div>
      </div>
    </>
  )
}

function replaceWithBr(s) {
  return s.replace(/\n/g, '<br />')
}

const Item = ({ title, img, background }) => {
  return (
    <div
      className={css(styles.containerItem)}
      style={{
        background: `url(/assets/${background})`,
        backgroundSize: 'cover',
        backgroundPosition: '50%',
      }}
    >
      <img
        src={`/assets/${img}`}
        alt={title}
        width="136"
        height="136"
        className={css(styles.image)}
      />
      <h3
        className={css(styles.itemH3)}
        dangerouslySetInnerHTML={{ __html: replaceWithBr(title) }}
      ></h3>
    </div>
  )
}

Item.propTypes = {
  title: PropTypes.string,
  img: PropTypes.string,
  background: PropTypes.string,
}

export default Optimization
